import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormHelper } from '@app/shared/helpers/form';
import { IRegistrationConfirm } from '@app/modules/auth/interface/registration-confirm';

@Component({
  selector: 'app-registration-withpin-confirm-form',
  templateUrl: './registration-withpin-confirm-form.component.html'
})
export class RegistrationWithpinConfirmFormComponent implements OnInit, AfterViewInit {
  @Input() public email: string;

  @Output() public submitEvent = new EventEmitter<IRegistrationConfirm>();

  public form: FormGroup;

  public get code(): FormGroup {
    return this.form.get('code') as FormGroup;
  }

  /**
   * @param fb
   * @param cdr
   */
  constructor(
    private readonly fb: FormBuilder,
    private readonly cdr: ChangeDetectorRef
  ) {}

  public ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  public ngOnInit(): void {
    this.createForm();
  }

  public submit(): void {
    FormHelper.markAllAsDirty(this.form);

    if (this.form.valid) {
      const model: IRegistrationConfirm = {
        code: '',
        email: this.email
      };

      for (const key of Object.keys(this.code.value)) {
        model.code += this.code.value[key];
      }

      this.submitEvent.emit(model);
      this.form.reset();
    }
  }

  private createForm(): void {
    this.form = this.fb.group({
      code: this.fb.group({})
    });
  }
}
